import { SplashScreenSdbTopic } from "@components/splash-screen/splash-screen-data";
/** Change all the status of SDB splash screens */
export function changeAllSdbSplashScreensStatus(status) {
  const sdbSplashScreens = Object.values(SplashScreenSdbTopic).reduce((splashScreens, topic) => ({
    ...splashScreens,
    [topic]: status
  }), {});
  return sdbSplashScreens;
}

/**
 * Parse the FueFlags. If parsing is not successful, it returns all the splash screens recognized in SDB as unseen
 * For other Splash Screens, it will keep the status as it is
 */
export function parseFueFlags(splashScreens, fueFlags) {
  try {
    const parsedFueFlags = JSON.parse(fueFlags);
    for (const topic in parsedFueFlags) {
      if (Object.values(SplashScreenSdbTopic).includes(topic)) {
        splashScreens.sdb[topic] = parsedFueFlags[topic];
      } else {
        splashScreens.other = {
          ...splashScreens.other,
          [topic]: parsedFueFlags[topic]
        };
      }
    }
    return splashScreens;
  } catch {
    // Make the splash screens unseen if the parsing fails
    return {
      sdb: changeAllSdbSplashScreensStatus("unseen"),
      other: splashScreens.other
    };
  }
}

/** Convert the splashScreens object to a string, to send it as payload to backend */
export function createSplashScreenPayload(splashScreens) {
  const allSplashScreens = {
    ...splashScreens.sdb,
    ...splashScreens.other
  };
  return JSON.stringify(allSplashScreens);
}